import bgDesktop from "assets/images/mobiles-lg.png";
import bgMobile from "assets/images/mobiles.png";
import { Logo } from "components";
import { config } from "constant";

export default function LastSection() {
  return (
    <section className="relative w-full min-h-[calc(100svh-2.5rem)] flex flex-col mt-5 rounded-[2.5rem] overflow-hidden">
      <picture>
        <source media="(min-width:1024px)" srcSet={bgDesktop} />
        <source media="(min-width:0px)" srcSet={bgMobile} />
        <img
          src={bgMobile}
          alt={config.title}
          className="w-full absolute inset-0 size-full object-cover"
        />
      </picture>
      <div className="relative w-full m-auto px-4">
        <Logo
          variant="logo-text-row"
          className="block w-full max-w-48 lg:max-w-[23rem] mx-auto"
        />
        <p className="block w-full text-xs lg:text-sm text-white text-center font-medium mt-5 lg:mt-9">
          Create by
        </p>
        <Logo
          variant="logo-team-light"
          className="block w-full max-w-[7.625rem] lg:max-w-[10rem] mt-1.5 lg:mt-2.5 mx-auto"
        />
      </div>
    </section>
  );
}
